module.exports = __webpack_public_path__ + "fonts/9168b79bb37edcf89b85e2376d914f64.txt";